module.exports = __webpack_public_path__ + "img/Villa_Borna_6.b6c173ca.jpg";